// src/store/userSlice.js
import { createSlice } from "@reduxjs/toolkit";

const userSlice = createSlice({
  name: "user",
  initialState: {
    currentUser: null,
  },
  reducers: {
    setUser(state, action) {
      const newUser = action.payload;
      if (newUser) {
        // Preserve referralId from current state or localStorage if new user doesn't have it
        const currentReferralId = (state.currentUser as any)?.referralId;
        const savedUser = JSON.parse(localStorage.getItem("user") || "null");
        const preservedReferralId =
          newUser.referralId || currentReferralId || savedUser?.referralId;

        state.currentUser = {
          ...newUser,
          referralId: preservedReferralId,
        } as any;
      } else {
        state.currentUser = null;
      }
    },
    logoutUser(state) {
      state.currentUser = null;
    },
  },
});

export const { setUser, logoutUser } = userSlice.actions;
export default userSlice.reducer;
